import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import ContactModal from "../home/hero/ContactModal";
import toast from "react-hot-toast";
import axios from "axios";

const styles = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;1,400&family=Syne:wght@300;400;500;600&display=swap');

.hiw-root *{box-sizing:border-box;margin:0;padding:0}
.hiw-root{
  --ink:#1E2A3A;
  --green:#4E8A3C;
  --green-light:#7BBF6A;
  --green-pale:#EBF5E7;
  --aqua:#7BBCC8;
  --aqua-pale:#E8F4F7;
  --gold:#C9A96E;
  --cream:#F7F6F2;
  --muted:#6B7A8D;
  --border:rgba(30,42,58,0.1);
  --white:#FFFFFF;
  font-family:'Syne',sans-serif;
  color:var(--ink);
  background:var(--white);
  width:100%;
  overflow-x:hidden;
}
.hiw-serif{font-family:'Playfair Display',Georgia,serif}

/* PAGE HEADER */
.hiw-header{
  background:linear-gradient(160deg, #C8DFC2 0%, #B8D8D8 50%, #A8C8D4 100%);
  padding:5rem max(2.5rem, calc((100vw - 1280px)/2 + 2.5rem)) 4rem;
  position:relative;overflow:hidden;
}
.hiw-header::before{
  content:'';position:absolute;inset:0;
  background:
    radial-gradient(ellipse at 80% 20%, rgba(255,255,255,0.4) 0%, transparent 55%),
    radial-gradient(ellipse at 15% 80%, rgba(123,188,200,0.2) 0%, transparent 50%);
  pointer-events:none;
}
.hiw-header-inner{position:relative;z-index:1}
.hiw-header-eyebrow{font-family:'Syne',sans-serif;font-size:10px;letter-spacing:2.5px;text-transform:uppercase;color:rgba(30,42,58,0.5);margin-bottom:0.75rem}
.hiw-header h1{font-family:'Playfair Display',serif;font-size:48px;color:var(--ink);font-weight:400;line-height:1.18;max-width:640px}
.hiw-header h1 strong{font-style:italic;color:var(--green)}
.hiw-header p{font-family:'Syne',sans-serif;font-size:14px;color:var(--muted);line-height:1.8;max-width:520px;margin-top:1.25rem;font-weight:300}

/* STEPS */
.hiw-steps-sec{padding:5rem max(2.5rem, calc((100vw - 1280px)/2 + 2.5rem));background:var(--cream)}
.hiw-eyebrow{font-family:'Syne',sans-serif;font-size:10px;letter-spacing:2.5px;text-transform:uppercase;color:var(--green);margin-bottom:0.6rem}
.hiw-h2{font-family:'Playfair Display',serif;font-size:32px;color:var(--ink);line-height:1.25;font-weight:400;margin-bottom:3rem}
.hiw-steps{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:1.5rem}
.hiw-step{position:relative}
.hiw-step::after{
  content:'→';position:absolute;top:22px;right:-16px;
  color:rgba(78,138,60,0.25);font-size:18px;font-weight:300;
}
.hiw-step:last-child::after{display:none}
.hiw-step-idx{
  width:46px;height:46px;border-radius:8px;
  background:white;
  border:1px solid rgba(78,138,60,0.2);
  border-left:3px solid var(--green);
  display:flex;align-items:center;justify-content:center;margin-bottom:1rem;
  box-shadow:0 1px 6px rgba(30,42,58,0.06);
}
.hiw-step-num{font-family:'Playfair Display',serif;font-size:18px;color:var(--green)}
.hiw-step h4{font-family:'Syne',sans-serif;font-size:13px;font-weight:500;color:var(--ink);margin-bottom:0.4rem}
.hiw-step p{font-family:'Syne',sans-serif;font-size:11px;color:var(--muted);line-height:1.65;font-weight:300}

/* DETAIL CARDS */
.hiw-detail-sec{padding:5rem max(2.5rem, calc((100vw - 1280px)/2 + 2.5rem));background:white}
.hiw-detail-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:1.5rem}
.hiw-card{
  border:1px solid rgba(78,138,60,0.12);
  border-top:3px solid var(--green);
  border-radius:10px;padding:2rem;
  display:flex;flex-direction:column;gap:0.75rem;
  background:white;transition:all 0.25s;
  box-shadow:0 2px 10px rgba(30,42,58,0.04);
}
.hiw-card:hover{background:var(--green-pale);box-shadow:0 6px 24px rgba(78,138,60,0.1);transform:translateY(-2px)}
.hiw-card-num{font-family:'Playfair Display',serif;font-size:42px;color:var(--green);opacity:0.15;line-height:1}
.hiw-card h3{font-family:'Playfair Display',serif;font-size:20px;font-weight:400;color:var(--ink);line-height:1.3}
.hiw-card p{font-family:'Syne',sans-serif;font-size:13px;color:var(--muted);line-height:1.75;font-weight:300}
.hiw-card-tags{display:flex;flex-wrap:wrap;gap:6px;margin-top:0.5rem}
.hiw-tag{font-family:'Syne',sans-serif;font-size:10px;padding:4px 10px;border-radius:20px;background:var(--green-pale);color:var(--green);letter-spacing:0.3px}

/* SUPPORT CALLOUT */
.hiw-support{
  background:linear-gradient(160deg, #3A5C35 0%, #4A6A60 50%, #3A5870 100%);
  margin:0 max(2.5rem, calc((100vw - 1280px)/2 + 2.5rem));
  border-radius:12px;padding:3rem;
  display:grid;grid-template-columns:1fr 1fr;gap:3rem;align-items:center;
  position:relative;overflow:hidden;
}
.hiw-support::before{
  content:'';position:absolute;inset:0;border-radius:12px;
  background:
    radial-gradient(ellipse at 15% 50%, rgba(200,223,194,0.15) 0%, transparent 55%),
    radial-gradient(ellipse at 85% 30%, rgba(123,188,200,0.12) 0%, transparent 50%);
  pointer-events:none;
}
.hiw-support-left{position:relative;z-index:1}
.hiw-support-left .hiw-eyebrow{color:var(--green-light)}
.hiw-support-left h2{font-family:'Playfair Display',serif;font-size:28px;color:white;font-weight:400;line-height:1.3;margin-top:0.5rem}
.hiw-support-left p{font-family:'Syne',sans-serif;font-size:13px;color:rgba(255,255,255,0.55);margin-top:0.75rem;line-height:1.75;font-weight:300}
.hiw-support-right{position:relative;z-index:1;display:flex;flex-direction:column;gap:10px}
.hiw-tile{
  display:flex;align-items:flex-start;gap:1rem;padding:1rem 1.25rem;
  background:rgba(255,255,255,0.07);
  border:1px solid rgba(255,255,255,0.12);
  border-radius:8px;transition:background 0.2s;
}
.hiw-tile:hover{background:rgba(255,255,255,0.12)}
.hiw-tile-icon{font-size:20px;flex-shrink:0;margin-top:2px}
.hiw-tile h4{font-family:'Syne',sans-serif;font-size:13px;font-weight:500;color:white;margin-bottom:0.2rem}
.hiw-tile p{font-family:'Syne',sans-serif;font-size:11px;color:rgba(255,255,255,0.45);line-height:1.55;font-weight:300}

/* CTA STRIP */
.hiw-cta{
  padding:4rem max(2.5rem, calc((100vw - 1280px)/2 + 2.5rem));
  background:var(--cream);
  display:flex;align-items:center;justify-content:space-between;gap:2rem;flex-wrap:wrap;
  border-top:1px solid rgba(78,138,60,0.1);
}
.hiw-cta p{font-family:'Syne',sans-serif;font-size:14px;color:var(--muted);max-width:460px;line-height:1.7;font-weight:300}
.hiw-cta-btns{display:flex;gap:12px;flex-shrink:0;flex-wrap:wrap}
.hiw-btn-green{background:var(--green);color:white;font-family:'Syne',sans-serif;font-size:12px;font-weight:500;padding:13px 26px;border-radius:6px;border:none;cursor:pointer;letter-spacing:0.5px;transition:background 0.2s}
.hiw-btn-green:hover{background:#3D7030}
.hiw-btn-outline{background:transparent;color:var(--ink);font-family:'Syne',sans-serif;font-size:12px;font-weight:500;padding:12px 26px;border-radius:6px;border:1px solid rgba(78,138,60,0.25);cursor:pointer;letter-spacing:0.5px;transition:all 0.2s}
.hiw-btn-outline:hover{border-color:var(--green);color:var(--green)}

/* RESPONSIVE */
@media (max-width: 768px) {
  .hiw-header{padding:3.5rem 1.5rem}
  .hiw-header h1{font-size:34px}
  .hiw-steps-sec{padding:3.5rem 1.5rem}
  .hiw-h2{font-size:26px;margin-bottom:2rem}
  .hiw-steps{grid-template-columns:1fr 1fr;gap:2rem}
  .hiw-step::after{display:none}
  .hiw-detail-sec{padding:3.5rem 1.5rem}
  .hiw-detail-grid{grid-template-columns:1fr}
  .hiw-support{grid-template-columns:1fr;gap:2rem;margin:0 1.5rem;padding:2rem}
  .hiw-cta{padding:3rem 1.5rem;flex-direction:column;align-items:flex-start}
}
@media (max-width: 480px) {
  .hiw-header{padding:2.5rem 1.25rem}
  .hiw-header h1{font-size:28px}
  .hiw-steps-sec{padding:3rem 1.25rem}
  .hiw-steps{grid-template-columns:1fr;gap:1.75rem}
  .hiw-detail-sec{padding:3rem 1.25rem}
  .hiw-support{margin:0 1.25rem;padding:1.75rem}
  .hiw-cta{padding:3rem 1.25rem}
  .hiw-cta-btns{width:100%}
  .hiw-btn-green,.hiw-btn-outline{width:100%;text-align:center}
}
@media (min-width: 1440px) {
  .hiw-header h1{font-size:56px}
  .hiw-h2{font-size:36px}
}
`;

const HowItWorks = () => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "", facility: "", city: "", state: "", zip: "",
    phone: "", email: "", question: "",
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFormData({ name: "", facility: "", city: "", state: "", zip: "", phone: "", email: "", question: "" });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, phone, question, facility, city, state, zip } = formData;
    if (!name || !facility || !city || !state || !zip || !phone || !email || !question) {
      toast.error("Please fill in all required fields."); return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email address."); return;
    }
    try {
      await axios.post("https://promedhealth-frontdoor-h4c4bkcxfkduezec.z02.azurefd.net/api/v1/contact-us/", formData);
      toast.success("Your message has been sent. We'll get back to you soon!");
      handleClose();
    } catch {
      toast.error("Failed to send message. Please try again.");
    }
  };

  const steps = [
    { n: "1", title: "Reach Out",      body: "Call, chat, or submit an inquiry. A real person responds within one business day—no automated runaround." },
    { n: "2", title: "Get Matched",    body: "Our team matches your clinical need with the right products, pricing tier, and protocol support." },
    { n: "3", title: "Order & Receive",body: "Fast fulfillment through our portal or preferred channels. Net 30 terms for qualified providers." },
    { n: "4", title: "Ongoing Support",body: "Member portal, live chat, billing help, and reorder access—your team is always within reach." }
  ];

  const details = [
    {
      n: "01", title: "Register & Verify",
      body: "Sign up as a provider and complete your profile. Our admin team reviews and approves your account, then you're ready to submit IVR forms.",
      tags: ["Fast Approval", "Secure Portal", "HIPAA Compliant"]
    },
    {
      n: "02", title: "Submit IVR Forms",
      body: "Submit Individual Verification Requirements forms directly through the portal. Our team reviews submissions quickly and keeps you updated on status.",
      tags: ["Real-time Status", "Admin Review", "Document Upload"]
    },
    {
      n: "03", title: "Place Your Order",
      body: "Once your IVR is approved, order ProPack™ kits and wound care products directly from your dashboard. Choose kit types based on wound characteristics.",
      tags: ["ProPack™ Kits", "EXU · POW · PAD", "Product Recommendations"]
    },
    {
      n: "04", title: "We Ship & Support",
      body: "Products are shipped directly to patients or your facility. Track deliveries, manage orders, and get ongoing billing and reimbursement support.",
      tags: ["Direct Shipping", "Order Tracking", "Billing Support"]
    }
  ];

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: styles }} />
      <div className="hiw-root">

        {/* PAGE HEADER */}
        <motion.div
          className="hiw-header"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="hiw-header-inner">
            <div className="hiw-header-eyebrow">How It Works</div>
            <h1 className="hiw-serif">
              Simple by <strong>design.</strong><br />Powerful in practice.
            </h1>
            <p>From your first inquiry to ongoing patient care — our process is built to reduce friction and keep you focused on what matters most.</p>
          </div>
        </motion.div>

        {/* 4-STEP OVERVIEW */}
        <section className="hiw-steps-sec">
          <div className="hiw-eyebrow">The Process</div>
          <h2 className="hiw-h2 hiw-serif">Four steps to better care delivery.</h2>
          <div className="hiw-steps">
            {steps.map((step, i) => (
              <motion.div
                key={i}
                className="hiw-step"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
              >
                <div className="hiw-step-idx">
                  <div className="hiw-step-num hiw-serif">{step.n}</div>
                </div>
                <h4>{step.title}</h4>
                <p>{step.body}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* DETAIL CARDS */}
        <section className="hiw-detail-sec">
          <div className="hiw-eyebrow">Step by Step</div>
          <h2 className="hiw-h2 hiw-serif" style={{ marginTop: '0.5rem' }}>What happens at each stage.</h2>
          <div className="hiw-detail-grid">
            {details.map((d, i) => (
              <motion.div
                key={i}
                className="hiw-card"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
              >
                <div className="hiw-card-num hiw-serif">{d.n}</div>
                <h3 className="hiw-serif">{d.title}</h3>
                <p>{d.body}</p>
                <div className="hiw-card-tags">
                  {d.tags.map((tag, j) => <span key={j} className="hiw-tag">{tag}</span>)}
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* SUPPORT CALLOUT */}
        <div className="hiw-support">
          <div className="hiw-support-left">
            <div className="hiw-eyebrow">Member Support</div>
            <h2 className="hiw-serif">Already with us?<br />We're right here.</h2>
            <p>Existing members get direct access to live support, documents, billing help, and reordering — no hold music, no ticket queue.</p>
          </div>
          <div className="hiw-support-right">
            {[
              { icon: "📄", title: "Download Documents", body: "Invoices, billing letters, compliance docs, and product guides." },
              { icon: "🔄", title: "Reorder Supplies",   body: "Quick reorder from your history — same products, same pricing." },
              { icon: "🧾", title: "Billing Help",        body: "HCPCS coding, workers' comp, and reimbursement support." },
              { icon: "📋", title: "Training Library",    body: "ProMed clinical guides, onboarding materials, and protocols." },
            ].map((tile, i) => (
              <motion.div
                key={i}
                className="hiw-tile"
                initial={{ opacity: 0, x: 16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: i * 0.08 }}
              >
                <div className="hiw-tile-icon">{tile.icon}</div>
                <div>
                  <h4>{tile.title}</h4>
                  <p>{tile.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* CTA STRIP */}
        <div className="hiw-cta">
          <p>Ready to get started? Our team responds within one business day. No automated runaround — a real person every time.</p>
          <div className="hiw-cta-btns">
            <button className="hiw-btn-green" onClick={handleOpen}>Talk to Our Team</button>
            <button className="hiw-btn-outline" onClick={handleOpen}>Request Info</button>
          </div>
        </div>

      </div>

      <AnimatePresence>
        {open && (
          <ContactModal open={open} handleClose={handleClose}
            formData={formData} handleChange={handleChange} handleSubmit={handleSubmit} />
        )}
      </AnimatePresence>
    </>
  );
};

export default HowItWorks;